import React from 'react';
import type { IdCardLayout } from '../../../types/idCards';
import type { CardFaceProps } from './faces/shared';
import ClassicFront from './faces/ClassicFront';
import SidebarFront from './faces/SidebarFront';
import PortraitFront from './faces/PortraitFront';
import MinimalFront from './faces/MinimalFront';
import CardBack from './faces/CardBack';

const FRONTS: Record<IdCardLayout, React.FC<CardFaceProps>> = {
  classic: ClassicFront,
  sidebar: SidebarFront,
  portrait: PortraitFront,
  minimal: MinimalFront,
};

export type CardSide = 'front' | 'back';

/** One side of a card, in the design's layout. */
const IdCardFace: React.FC<CardFaceProps & { side: CardSide }> = ({ side, ...props }) => {
  if (side === 'back') return <CardBack {...props} />;
  const Front = FRONTS[props.design.layout] ?? ClassicFront;
  return <Front {...props} />;
};

export default IdCardFace;
